import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { EmployeesGroupFooter, EmployeesGroupList } from "./components";

const Header = (): JSX.Element => (
  <BoldText className={styles.groupTitle}>Группы сотрудников</BoldText>
);

export const EmployeesGroup = (): JSX.Element => {
  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3", styles.container)}
      header={<Header />}
      footer={<EmployeesGroupFooter />}
    >
      <EmployeesGroupList />
    </BaseLayout>
  );
};
